<template>
  <button class="play-gate" type="button" aria-label="Enter game" title="Tap to enter game" @click="$emit('enter')">
    <span class="tap-indicator" aria-hidden="true">
      <span class="tap-rings">
        <i></i>
        <i></i>
        <i></i>
      </span>

      <svg class="tap-hand" viewBox="0 0 64 64" fill="none">
        <path d="M31 31V13.5a5 5 0 0 1 10 0V30" />
        <path d="M41 28v-8a4.5 4.5 0 0 1 9 0v13" />
        <path d="M50 30v-5a4 4 0 0 1 8 0v12c0 11.6-8.9 19-20.5 19H34c-9.7 0-17.3-6.4-19.7-15.3l-2-7.5a4.8 4.8 0 0 1 9-3.2L25 38V18a5 5 0 0 1 10 0v13" />
        <path class="tap-touch" d="M19 9a18 18 0 0 1 9-5" />
        <path class="tap-touch" d="M13 17a28 28 0 0 1 13-9" />
      </svg>
    </span>

    <span class="play-gate-copy">
      <strong>Tap to enter game</strong>
      <small>Resume in fullscreen</small>
    </span>
  </button>
</template>

<script setup>
defineEmits(['enter'])
</script>

<style scoped>
.play-gate{position:absolute;inset:0;z-index:30;width:100%;height:100%;display:grid;place-items:center;align-content:center;gap:9px;padding:0;border:0;background:linear-gradient(180deg,rgba(3,8,15,.22),rgba(3,8,15,.42));-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);color:rgba(148,163,184,.62);cursor:pointer;touch-action:manipulation;user-select:none;overflow:hidden}
.play-gate::before{content:"";position:absolute;inset:0;background:radial-gradient(circle at center,rgba(10,23,39,.02) 0%,rgba(4,10,18,.10) 38%,rgba(0,0,0,.28) 100%);pointer-events:none}
.play-gate:active{background:linear-gradient(180deg,rgba(3,8,15,.28),rgba(3,8,15,.48))}
.tap-indicator{position:relative;width:96px;height:96px;display:grid;place-items:center;border-radius:999px;background:radial-gradient(circle at center,rgba(8,20,34,.46),rgba(5,11,18,.22) 64%,transparent 72%);filter:drop-shadow(0 8px 20px rgba(0,0,0,.18));opacity:.78}
.tap-rings{position:absolute;inset:0;display:grid;place-items:center}
.tap-rings i{position:absolute;width:54px;height:54px;border:1px solid rgba(148,163,184,.32);border-radius:999px;box-shadow:0 0 10px rgba(148,163,184,.08);animation:tap-wave 2.2s ease-out infinite}
.tap-rings i:nth-child(2){animation-delay:.55s}.tap-rings i:nth-child(3){animation-delay:1.1s}
.tap-hand{position:relative;z-index:1;width:54px;height:54px;stroke:rgba(186,198,211,.68);stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;filter:none;transform:translate(2px,2px)}
.tap-touch{stroke:rgba(166,179,194,.52);stroke-width:2}
.play-gate-copy{position:relative;z-index:1;display:grid;justify-items:center;gap:2px;text-align:center;opacity:.76}
.play-gate-copy strong{padding:4px 9px;border-radius:999px;background:rgba(2,6,11,.20);color:rgba(196,205,216,.74);font-size:10px;font-weight:700;letter-spacing:.02em;text-shadow:none}
.play-gate-copy small{color:rgba(166,179,194,.58);font-size:8px;letter-spacing:.02em;text-shadow:none}
@keyframes tap-wave{0%{transform:scale(.68);opacity:0}18%{opacity:.50}100%{transform:scale(1.72);opacity:0}}
@media(max-width:420px){.tap-indicator{width:84px;height:84px}.tap-hand{width:48px;height:48px}.tap-rings i{width:48px;height:48px}.play-gate-copy strong{font-size:9px}.play-gate-copy small{font-size:7px}}
@media(prefers-reduced-motion:reduce){.tap-rings i{animation:none}.tap-rings i:nth-child(n+2){display:none}}
</style>
